import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { LinkUsersService } from '../../services/link-user.service';
import { Extensions } from '../../classes/static/extensions';
import { IInitiateLinkProcessResponse } from '../../classes/http-responses';
import { ICodeService } from '../../services/icode.service';
import { IErrorDescription } from '@ibank-globals/error';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandler } from '../../../globals/classes/errorHandler';
import { UserData } from '../../../globals/classes/userData';
import { BaseComponent } from '../../../globals/classes/base.component';
import { finalize } from 'rxjs/operators/finalize';

@Component({
	template: require('./switch-users-modal.component.html'),
})
export class SwitchUsersModalComponent extends BaseComponent implements OnInit, AfterViewInit {
	@Input() targetUserId: string;

	public isInitialized: boolean;
	public loading: boolean = true;
	private isCorporate: boolean;

	constructor(private activeModal: NgbActiveModal, private icodeService: ICodeService) {
		super();
	}

	ngOnInit(): void {
		this.mortalize(UserData.isCorporate$).subscribe(
			(isCorporate) => (this.isCorporate = isCorporate)
		);
	}

	ngAfterViewInit() {
		this._initiateProcess();
	}

	public closeModal(): void {
		window.location.href = Extensions.returnUrl;
	}

	private _submit(): void {
		if (!this.isInitialized) return;
		this.loading = true;
		LinkUsersService.completeUserSwitch({
			userId: this.targetUserId,
			returnUrl: Extensions.returnUrl,
		})
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(result) => {},
				(error) => this.handleInitiateError(error)
			);
	}

	private _initiateProcess(): void {
		LinkUsersService.initiateUserSwitch({
			userId: this.targetUserId,
		}).subscribe(
			(response) => this.handleInitiateResponse(response),
			(error) => this.handleInitiateError(error)
		);
	}

	private handleInitiateResponse(response: IInitiateLinkProcessResponse): void {
		if (!response) return;
		this.isInitialized = true;
		this._submit();
	}

	private handleInitiateError(error: IErrorDescription): void {
		this.activeModal.close();
		ErrorHandler.newError(error);
	}
}
